<template lang="pug">
    ul.area-list.scrollbar.is-scrollable(ref="list")
        ElSkeleton(
            v-if="loading" 
            v-for='item in 8'
            :key="`skel-${item}`"
            style="padding: 8px 16px"
            animated
        )
            template(slot="template")
                div
                    ElSkeletonItem(style="width: 5%; height: 10px")
                div
                    ElSkeletonItem(style="width: 20%; height: 14px")
                div
                    ElSkeletonItem(style="width: 35%; height: 10px; margin-right: 32px")
                    ElSkeletonItem(style="width: 15%; height: 10px")
        li.area-item.l-flex-row--between(
            v-show="!loading"
            v-for="(point, index) in points"
            :key="`pts-${getSelectedPoint(point)}`"
            :class="{ 'errors': point.errors, focus: getSelectedPoint(point) === focusedPoint.index }"
            @click="handleClickOnPoint(getSelectedPoint(point), point)"
            :id="`point-${index}`"
        )
            div.area-item-info
                div.area-item-id.georadar-id.area-item-info-small {{ point.id }}
                div.area-item-label.georadar-label(
                    :title="point.label"
                    :class="getStatusDot(point.action)"
                ) {{ point.label }}
                div.area-item-volume.area-item-info-small(v-if="point.volumes") {{ point.volumes }}

                div.l-flex-row.georadar-row
                    div.l-flex-row.georadar-row-coordinates
                        svg-icon(name="georadar-world" size="medium" title="georadar-world")
                        span.area-item-coordinates.area-item-info-small {{ point.latitude + ' , ' + point.longitude }}
                    div.l-flex-row.georadar-radius
                        svg-icon(name="georadar-radius" size="medium" title="georadar-radius")
                        div.area-item-coordinates.area-item-info-small  {{ point.radius + ' km' }}
                    
            div.l-flex-row
                template(v-if="point.action !== 'delete'")
                    div.item_action.icon-wrapper(@click="openUpdateForm(getSelectedPoint(point), point)")
                        svg-icon(name='edit' size="medium" title="edit")
                    div.item_action.icon-wrapper(@click.stop="handleDelete(getSelectedPoint(point), point)")
                        svg-icon(name='trash' size="medium" title="delete")
                div.item_action.icon-wrapper(
                    v-else
                    @click.stop="handleCancelDelete(getSelectedPoint(point), point)"
                )
                    svg-icon(name='close' size="medium" title="cancel delete")
</template>

<script>
import { mapMutations } from 'vuex'
import { isEqual } from 'lodash'

export default {
    name: 'GeoradarPointsList',

    props: {
        points: {
            type: Array,
            required: true
        },
        loading: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        focusedPoint() {
            return this.$store.state.ui.georadar.focusedPoint
        },
        savedPoints() {
            return this.$store.state.data.georadar.savedPoints
        }
    },

    watch: {
        focusedPoint: {
            handler({ index, shouldScroll }) {
                if (index != undefined && shouldScroll) {
                    this.scrollTo(index)
                }
            },
            deep: true
        }
    },

    methods: {
        ...mapMutations('ui/georadar', ['setForm', 'setFormAction', 'setFormUpdateInfos', 'setFocusedPoint']),
        ...mapMutations('data/georadar', ['deleteUnsavedPoint', 'setPoint']),

        handleClickOnPoint(index, point) {
            if(point.errors === undefined) {
                this.$emit('handleClickOnPoint', { index, value: point })
            }
            
        },

        scrollTo(index) {
            this.$nextTick(() => {
                const element = document.getElementById(`point-${index}`)
                if (element) {
                    this.$refs.list.scrollTo({
                        left: 0,
                        top: element.offsetTop - 112,
                        behavior: 'smooth'
                    })
                }
            })
        },

        handleDelete(index, point) {
            if (point.action === 'create') {
                this.deleteUnsavedPoint(index)
                this.setFocusedPoint({ index: undefined })
            } else {
                this.setFocusedPoint({ index, shouldScroll: false, shouldFlyEvenIfInMap: true })
                this.setPoint({ index, value: { ...point, action: 'delete' } })
            }
        },

        handleCancelDelete(index, point) {
            this.setFocusedPoint({ index, shouldScroll: false, shouldFlyEvenIfInMap: true })
            const savedPoint = this.savedPoints.find(p => p.id == point.id)
            const isUpdated =
                point.label != savedPoint.label ||
                point.radius != savedPoint.radius ||
                point.longitude != savedPoint.longitude ||
                point.latitude != savedPoint.latitude
            this.setPoint({ index, value: { ...point, action: isUpdated ? 'update' : 'noAction' } })
        },

        openUpdateForm(index, value) {
            this.setFocusedPoint({ index, shouldScroll: false, shouldFlyEvenIfInMap: true })
            this.setForm({ ...value })
            this.setFormUpdateInfos({ index })
            this.setFormAction('update')
        },

        getStatusDot(action) {
            const _colors = {
                delete: 'status-dot red',
                update: 'status-dot orange',
                create: 'status-dot green'
            }
            return _colors[action]
        },

        getSelectedPoint(selectedPoint) {
            return this.points.findIndex((point) => isEqual(point, selectedPoint))
        }
    }
}
</script>
